/*eslint-disable*/
import _ from 'lodash'
import SchoolApi from '../../api/school'

export default [
    {
        path: 'school/create',
        name: 'school:create',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "school" */'../../components/school/Create.vue'),
        meta: {
            title: 'router.router_addSchool',
            prev: {
                name: 'school:list'
            }
        }
    },
    {
        path: 'school/:id',
        name: 'school:profile',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "school" */'../../components/profiles/School.vue'),
        meta: {
            title: _.throttle((route) => {
                return SchoolApi.show(route.params.id).then((school) => {
                    return school.name;
                });
            }, 100, {trailing: false}),
            prev: {
                name: 'school:list'
            }
        },
        props: true
    },
    {
        path: 'school/:id/edit',
        name: 'school:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "school" */'../../components/school/Edit.vue'),
        meta: {
            title: 'router.router_editSchool',
            prev: {
                name: 'school:profile'
            }
        },
        props: true
    },
]
